export const TabItems = [
    {
        name_ar:"الطلاب",
        name: "Students",
        path: "Students",
        link: "/dashboard/students"
    },
    {
        name_ar:"الآباء",
        name: "Parents",
        path: "Parents",
        link: "/dashboard/parents"
    },
    {
        name_ar:"المساعدون",
        name: "Assistants",
        path: "Assistants",
        link: "/dashboard/assistants"
    },
    // {
    //     name: "staff",
    //     link: "/dashboard/staff"
    // },
    {
        name_ar:"الطلاب الجدد",
        name: "New Students",
        path: "Pending requests",
        link: "/dashboard/pending-requests"
    },
    {
        name_ar:"طلبات التعديل",
        name: "Edit requests",
        path: "Edit requests",
        link: "/dashboard/edit-requests"
    },
    {
        name_ar:"طلبات الأستئذان المبكر",
        name: "Early dismissal requests",
        path: "Early dismissal requests",
        link: "/dashboard/early-dismissal-requests"
    },
    // Navigation hidden — the old upload flow is superseded by the bulk import
    // under data management. The /dashboard/upload route and its component are
    // kept, so the page is still reachable by URL.
    // {
    //     name_ar:"استيراد البيانات",
    //     name: "Upload",
    //     path: "Upload",
    //     link: "/dashboard/upload"
    // }
]

export const BusesTabItems = [
    {
        name_ar:"المشتركون فى الحافلة",
        name: "Bus subscribers",
        path: "students",
        link: "/buses/students"
    },
    {
        name_ar:"طلبات الحافلات",
        name: "Bus requests",
        path: "bus requestes",
        link: "/buses/bus-requestes"
    }
]

export const SchoolManagementTabItems = [
    {
        name_ar:"معلومات المدرسة",
        name: "School info",
        link: "/school-management/school-info"
    },
    {
        name_ar:"وقت الإنصراف",
        name: "Dismissal time",
        link: "/school-management/dismissal-time"
    },
    {
        name_ar:"الفريق الدراسي",
        name: "Staff",
        link: "/school-management/staff"
    },
    {
        name_ar:"الصفوف الدراسية والفصول",
        name: "Grades & Classes",
        link: "/school-management/grades-classes"
    },
    {
        name_ar:"الأقسام",
        name: "Sections",
        link: "/school-management/sections"
    },
    {
        name_ar:"بوابات",
        name: "Gates",
        link: "/school-management/gates"
    },
    {
        name_ar:"آلية الانصراف",
        name: "Dismissal flow",
        link: "/school-management/dismissal-flow"
    }
]

export const DataManagementTabItems = [
    {
        name_ar:"الطلاب",
        name: "Students",
        path: "Students",
        link: "/data-management/students"
    },
    // {
    //     name_ar:"الموظفين",
    //     name: "Staff Members",
    //     path: "Staff",
    //     link: "/data-management/staff"
    // }
]

export const AppointmentsTabItems = [
    // Hidden for Phase 2
    // {
    //     name_ar:"الإعدادات",
    //     name: "Settings",
    //     path: "settings",
    //     link: "/appointments/settings"
    // },
    // {
    //     name_ar:"الطلبات",
    //     name: "Requests",
    //     path: "requests",
    //     link: "/appointments/requests"
    // }
]